import React, { useEffect } from 'react';
import { RecoilState, useRecoilState } from 'recoil';
import { Checkbox, FormLabel } from '@tq/ui-components';

export type IsRegisteredCheckboxProps = {
  defaultValue?: string;
  label: string;
  recoilState: RecoilState<string>;
  inputId: string;
};

export const IsRegisteredCheckbox: React.FC<IsRegisteredCheckboxProps> = ({
  label,
  recoilState,
  inputId,
  defaultValue,
}) => {
  const [isRegistered, setIsRegistered] = useRecoilState(recoilState);

  useEffect(() => {
    if (defaultValue) setIsRegistered(defaultValue);
  }, [setIsRegistered, defaultValue]);

  return (
    <>
      <FormLabel htmlFor={inputId} mb={{ base: 0, lg: '.75rem' }}>
        {label}
      </FormLabel>
      <Checkbox
        isChecked={isRegistered.toLowerCase() === 'true'}
        onChange={() =>
          setIsRegistered(isRegistered.toLowerCase() === 'true' ? 'false' : 'true')
        }
      />
    </>
  );
};
